import { Layout, Row, Col, Modal, Button as AntdButton, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

import Icon from "../SideNavIcon";
import { logout } from "../../Redux/AuthSlice";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../assets/Images/Frame 45.png";
import COLORS from "../../common/Colors";

const AntHeader = Layout.Header;

const StyledAntHeader = styled(AntHeader)`
  background: #ffffff;
  z-index: 9;
  height: auto;
  line-height: 1.2;
  padding: 10px 0px;
  border-bottom: 1px solid #f0f0f0;
  h3 {
    padding-left: 20px;
  }

  .header_logo_title {
    margin: 0px;
    margin-left: 6px;
    cursor: pointer;
  }

  .left-header-skeleton {
    margin: 10px;
  }
  .right-header-skeleton {
    margin: 10px;
  }
`;

const RightCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  span{
    font-weight: bold;
    color:  ${COLORS.sidebar};

  }
`;

const ButtonIcon = styled(AntdButton)`
  padding-left: 5px;
  padding-right: 5px;
  width: auto !important;
  border-radius: 5px !important;
  font-weight: 600 !important;

  svg {
    margin-right: 0px !important;
  }
`;

const ButtonContainer = styled.div`
  padding: 0px 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* flex-wrap: wrap; */
  gap: 14px;
`;

const Header = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const logoutUser = () => {
    Modal.confirm({
      title: "Confirm",
      icon: "",
      content: "Are you sure you want to Logout?",
      okText: "Logout",
      cancelText: "Cancel",
      onOk: () => {
        // resetRedux()
        dispatch(logout());
        // localStorage.removeItem("isLoggedIn");
        // dispatch(setIsLoggedIn(false))
        navigate("/login");
      },
    });
  };

  const logoStyle = {
    padding: "0px 10px",
    width: "150px",
  };

  const userInfo = useSelector((state) => state.authTracking.userInfo);

  return (
    <StyledAntHeader>
      <Row>
        <Col xs={16}>
          <Row>
            <Col>
              <img style={logoStyle} src={logo} alt="logo" />
            </Col>
          </Row>
        </Col>

        <RightCol xs={8}>
          <span>Hello! {userInfo?.name}</span>

          <ButtonContainer>
            <Tooltip title="Logout">
              <ButtonIcon onClick={logoutUser}>
                <Icon name="logout" />
              </ButtonIcon>
            </Tooltip>
          </ButtonContainer>
        </RightCol>
      </Row>
    </StyledAntHeader>
  );
};

export default Header;
